export enum Breakpoints {
  min = 0,
  xs = 376,
  sm = 576,
  md = 768,
  lg = 992,
  xl = 1200,
  xxl = 1400,
}